import type { ItemType } from './items'

/**
 * The time an item needs when the user has not said: by type, in minutes. Shown as an
 * assumption ("≈ 1 h, the default for a review"), never as if the user had set it. The planner
 * (packages/insights) and the web app read this one table.
 */
export const DEFAULT_ESTIMATE_MINUTES: Readonly<Record<ItemType, number>> = {
  reply: 15,
  decision: 30,
  admin: 30,
  review: 60,
  meeting: 60,
  other: 60,
  fix: 120,
  deliverable: 240,
}

/** The default for an item without a type. */
export const DEFAULT_ESTIMATE_UNTYPED = 60
